module.exports = __webpack_public_path__ + "static/img/technology12.f31f9f14.png";